import isSecondaryPage from './isSecondaryPage';

export default ( currentPath, prevPath ) => {    
    return !!(
        isSecondaryPage( currentPath ) &&
        typeof window !== `undefined` && 
        window.___APP_INITIAL_RENDER_COMPLETE && 
        (prevPath && currentPath !== prevPath)
    )
}